
import { Component, Vue } from 'vue-property-decorator';

// 列表配置
const OPTION_LIST = [
  {
    title: '排序',
    dataIndex: 'sort',
    align: 'center',
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: '名称',
    align: 'center',
    dataIndex: 'name',
  },
  {
    title: '上架状态',
    align: 'center',
    dataIndex: 'is_show',
    scopedSlots: { customRender: 'show' },
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/style`,
};

@Component
export default class Product extends Vue {
  columns = OPTION_LIST; // 列表配置
  data_source = []; // 风格列表数据
  is_show = false; // 是否展示编辑下架弹框
  is_show_add = false; // 是否展示新增风格弹框
  is_show_edit = false; //是否展示编辑风格弹框
  is_loading = false; // 加载状态
  max_length = 3; // 新增风格输入框可输入字符最大长度
  text_length = 3; // 可输入文本的剩余长度
  edit_form = { id: 0, name: '', is_show: 0 }; // 编辑该项数据
  style_name = '';
  page = 1;
  table_data = {};
  form = {
    error: '',
    status: '',
  };
  // 获取列表信息
  created() {
    this.query();
  }
  // 请求列表数据
  async query(page = 1) {
    this.page = page;
    this.is_loading = true;
    const { data } = await this.$axios.get(API.query, {
      params: { current: this.page },
    });
    this.is_loading = false;
    if (data.status !== 200) return;
    this.data_source = data.data.detail;
    this.table_data = data.data;
  }
  // 上下架请求
  async changShow(is_show: number) {
    const { data } = await this.$axios.put(
      `${API.query}/${this.edit_form.id}`,
      {
        id: this.edit_form.id,
        is_show,
      }
    );
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    return data;
  }
  // 显示下架弹框
  handleStatusDown(data: any) {
    this.edit_form = data;
    this.is_show = true;
  }
  // 提交上架状态
  async handleStatusUp(info: any) {
    this.edit_form = info;
    const data = await this.changShow(1);
    if (!data) return;
    this.$message.success('上架成功');
    this.query(this.page);
  }
  // 提交下架状态
  async submitStatus() {
    this.is_show = false;
    const data = await this.changShow(2);
    if (!data) return;
    this.$message.success('下架成功');
    this.query(this.page);
  }
  // 显示新增风格弹框
  handleAddStyle() {
    this.is_show_add = true;
  }
  // 提交添加风格
  async submitAddStyle() {
    // 验证风格名称是否填写
    const flag = this.validatorStyleName(this.style_name);
    // 验证风格名称是否填写
    if (!flag) {
      return;
    }
    const { data } = await this.$axios.post(API.query, {
      name: this.style_name,
    });
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    this.is_show_add = false;
    this.style_name = '';
    this.$message.success('添加成功');
    this.query(this.page);
  }
  // 显示编辑弹框
  handleEdit(data: any) {
    this.is_show_edit = true;
    this.edit_form = Object.assign({}, data);
  }
  // 提交编辑结果
  async submitEditOk() {
    const flag = this.validatorStyleName(this.edit_form.name);
    // 验证风格名称是否填写
    if (!flag) {
      return;
    }
    const { data } = await this.$axios.put(
      `${API.query}/${this.edit_form.id}`,
      {
        id: this.edit_form.id,
        name: this.edit_form.name,
      }
    );
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    this.is_show_edit = false;
    this.$message.success('编辑成功');
    this.query(this.page);
  }
  // 取消事件
  handleCancel() {
    this.is_show = false;
    this.is_show_add = false;
    this.is_show_edit = false;
    this.style_name = '';
    this.form.status = '';
    this.form.error = '';
  }
  // 提交排序
  async submitSortEdit(item_data: any) {
    // 判断排序值是否发生改变或者是否为空
    if (item_data.sort !== '') {
      const { data } = await this.$axios.put(`${API.query}/${item_data.id}`, {
        id: item_data.id,
        sort: item_data.sort,
      });
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('编辑成功');
      this.query(this.page);
    }
  }
  // 处理输入事件，动态计算可输入的剩余字数
  handleInput(str: string) {
    return this.max_length - str.length;
  }
  // 验证风格名字是否填写
  validatorStyleName(style_name: string) {
    if (style_name !== '') {
      this.form.status = '';
      this.form.error = '';
      return true;
    }
    this.form.status = 'error';
    this.form.error = '请填写风格名称';
    return false;
  }
  // 分页
  paginationOption(data: Pagination<any>) {
    return {
      total: data.total || 0,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }
  // 页数改变
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }
}
